// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1ZIEQ","addWidgetButton":"Header_addWidgetButton__10rWk","dashboardTabs":"Header_dashboardTabs__3fCbg","active":"Header_active__i2Cw3"};